import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const { className, userData, ...rest } = props;

  const classes = useStyles();

  let avatarlink = '/images/avatars/male.png'
  console.log(userData, "userData")
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={avatarlink}
        to="/account"
      />
      <Typography className={classes.name} variant="h5">
        {userData?.name}
      </Typography>
      <Typography className={classes.name} variant="body1">
        {userData?.email}
      </Typography>
      <Typography className={classes.name} variant="body1">
        {userData?.type}
      </Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
